<template>
  <div id="delay-model">
    <ipub-model :title="`Send Email`"
                width="800px"
                class="copyright-documents"
                :visable="isVisable"
                @cancel="cancel"
                :showFooter="true"
                confirmText="Submit"
                @confirm="submit">
      <div class="submit-form">
        <ipub-form :model="params">
          <ipub-form-item prop="selectLetter"
                          label="Select Letter"
                          class="mar-b-20">
            <ipub-select v-model="params.templateId"
                         @change="queryTemplate"
                         :options="templateList"
                         optionTitle="subject"
                         placeholder="Select Letter" />
          </ipub-form-item>

          <ipub-form-item prop="fromId"
                          label="From"
                          class="mar-b-20">
            <ipub-select v-model="params.fromId"
                         :disabled="true"
                         optionTitle="email">
              <ipub-select-option :value="detail.from.id">{{detail.from.email}} &lt;{{detail.from.email}}&gt;</ipub-select-option>
            </ipub-select>
          </ipub-form-item>

          <ipub-form-item prop="to"
                          label="To"
                          class="mar-b-20">
            <ipub-input placeholder="Seperate with “,”"
                        :disabled="!detail.toDisplay"
                        v-model.trim="params.to" />
          </ipub-form-item>
          <ipub-form-item prop="cc"
                          label="CC"
                          v-if="detail.ccDisplay"
                          class="mar-b-20">
            <ipub-input placeholder="Seperate with ‘,’"
                        v-model.trim="params.cc" />
          </ipub-form-item>
          <ipub-form-item prop="bcc"
                          label="BCC"
                          v-if="detail.bccDisplay"
                          class="mar-b-20">
            <ipub-input placeholder="Seperate with ‘,’"
                        v-model.trim="params.bcc" />
          </ipub-form-item>
          <ipub-form-item prop="subject"
                          label="Letter Subject"
                          class="mar-b-20">
            <ipub-input placeholder="Letter Subject"
                        v-model.trim="params.subject" />
          </ipub-form-item>
          <ipub-form-item prop="letterBody"
                          label="Letter Body">
            <ipub-editor placeholder=""
                         :height="400"
                         v-model.trim="params.body" />
          </ipub-form-item>
          <ipub-form-item v-if="detail.allowAttach">
            <ipub-upload-label style="min-width:300px;position: relative;"
                               label="Attachment(s)"
                               multiple
                               :domain="domain"
                               :loading="loading"
                               @change="handleUpload"
                               :fileList="params.mailFileList" />
            <ipub-tooltip placement="right"
                          style="position: absolute;left: 98px;top:0;">
              <div slot="title"
                   style="width:190px;">
                The total size of attachments must be less than 20M.
              </div>
              <ipub-icon class="ipub-cursor-pointer"
                         type="iconInfo" />
            </ipub-tooltip>
          </ipub-form-item>
        </ipub-form>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mailAction } from '@/api/mail'
import help from '@/utils/help'
import { getUploadConfig } from '@/utils/upload'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    event: {
      type: String,
      default: '',
    },
    inputData: {
      type: Object,
      default () {
        return {}
      },
    },
    files: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      // 已有数据
      detail: {
        from: {}
      },
      // 提交数据
      params: {
        fromId: '',
        to: '',
        templateId: '',
        mailFileList: []
      },
      templateList: [],
      download: help.download,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain'
    })
  },
  watch: {
    isVisable: {
      async handler (val) {
        if (val) {
          this.params.event = this.event
          this.params.manuscriptId = this.inputData.manuscriptId
          this.params.sign = this.inputData.sign
          this.$set(this.params, 'mailFileList', this.files || [])
          await this.getTemplate()
        }
      },
      immediate: true
    }
  },
  methods: {
    async getTemplate () {
      this.templateList = await mailAction.template(this.event)
      if (this.templateList && this.templateList.length) {
        this.params.templateId = this.templateList[0].id
        this.queryTemplate(this.templateList[0].id)
      }
    },
    async queryTemplate (templateId) {
      const data = Object.assign(this.inputData, { templateId })
      this.detail = await mailAction.templateQuery(this.event, data)
      this.params.fromId = this.detail.from ? this.detail.from.id : ''
      this.params.to = this.detail.to
      this.params.cc = this.detail.cc
      this.params.bcc = this.detail.bcc
      this.params.body = this.detail.body
      this.params.subject = this.detail.subject
      this.params.replyToEmail = this.detail.replyToEmail
    },
    async handleUpload (files) {
      const file = files[0]
      const MS = 20
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }

      const path = `publisher/${this.publisherId}/sendEmail/${this.params.fromId
        }/${help.guid()}`
      this.loading = true

      const url = await getUploadConfig(file, path)
      this.loading = false
      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.params.mailFileList[this.params.mailFileList.length - 1] = {
        path: url,
        name: file.name,
        size: file.size
      }
    },
    // delFile (index) {
    //   this.params.mailFileList.splice(index, 1)
    // },
    async submit () {
      let total = 0
      const MS = 20
      this.files && this.files.forEach(ele => {
        const singleSize = ele.size / 1024 / 1024
        total = total + singleSize

      });
      if (total > MS) {
        this.$message.error({
          title: 'Error',
          content: 'The total size of attachments must be less than 20M.'
          // content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      } else {
        await mailAction.send(this.params)
        this.$message.success({
          title: 'Success',
          content: 'The email has been sent!'
        })
        this.$emit('send')
        // this.$emit('cancel')
      }
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
